import { useTheme } from "@mui/material";
import { tokens } from "../../global/theme/tokens";
import generateShades from "../../global/theme/ColorShades";

const SuccessCheck = ({ width = "120", height = "120" }) => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode, theme.palette.colorTheme);
  const shades = generateShades(colors.success, 5, 3);

  return (
    <svg
      width={width + "px"}
      height={height + "px"}
      viewBox="0 0 133 133"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g
        className="check-group"
        stroke="none"
        stroke-width="1"
        fill="none"
        fill-rule="evenodd"
      >
        <circle
          className="filled-circle"
          fill={shades[3]}
          cx={133 / 2}
          cy={133 / 2}
          r="54.5"
        />
        <circle
          className="white-circle"
          fill={shades[6]}
          cx={133 / 2}
          cy={133 / 2}
          r="55.5"
        />
        <circle
          className="outline-circle"
          stroke={shades[3]}
          stroke-width="4"
          cx={133 / 2}
          cy={133 / 2}
          r="54.5"
        />
        <polyline
          className="check"
          stroke={shades[6]}
          stroke-width="5.5"
          points="41 70 56 85 92 49"
        />
      </g>
    </svg>
  );
};

export default SuccessCheck;
